<template>
	<div>
		<PageHeaderLayout>
			<el-button type="" style="margin-bottom: 10px;" @click="goBack()"  icon="el-icon-back" size="medium">
				返回
			</el-button>
			<div class="main-page-content" style="margin-top: 20px;">
				<el-row>
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item label="办理状态" prop="c_type">
							<el-select v-model="searchCondition.status" filterable clearable placeholder="请选择">
								<el-option
									v-for="item in typeList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item label="手机号码">
							<el-input v-model="searchCondition.contact_phone" placeholder="输入手机号码" clearable></el-input>
						</el-form-item> -->
						<el-form-item label="时间">
							<DatePicker @dataSearch="dataSearch" :disabled="disabled"/>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton" :disabled="disabled" >查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="dataList"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					highlight-current-row
					@switchPaging="switchPaging"
				>
					<el-table-column
						align="center"
						label="状态">
						<template slot-scope="scope">
							<div>
								{{ scope.row.status==2?'审核拒绝':scope.row.status==1?'审核通过':'待审核'}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="180"
						align="left"
						label="操作"
					>
						<template slot-scope="scope">
							<el-button size="mini" type="primary" v-if="(scope.row.status==0)&&(userPermissions.indexOf('paihuo_examine_audit') != -1)&&company_status==1" @click="examine(scope.row.id)">审核</el-button>
							<el-button size="mini" type="infor" v-if="userPermissions.indexOf('paihuo_examine_view') != -1" @click="toInfo(scope.row.id)">项目详情</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
		<ModalDialog :dialogData="exDialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
			<template slot="content">
				<el-form :model="refuseData" :rules="refuseRules" ref="refuseForm" label-position="right" label-width="96px">
					<el-form-item>
						<el-radio v-model="refuseData.status" label="1">审核通过</el-radio>
						<el-radio v-model="refuseData.status" label="2">审核拒绝</el-radio>
					</el-form-item>
					<el-form-item label="拒绝原因" prop="remark" v-if="refuseData.status==2">
						<el-input v-model="refuseData.remark" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
					</el-form-item>
				</el-form>
			</template>
		</ModalDialog>
	</div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
import ApeTable from "@/components/ApeTable";
import ScreeCompany from '@/components/ScreeCompany.vue'
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'
export default {
	components: {
		PageHeaderLayout,
		ApeTable,
		ModalDialog,
		UploadFile,
		ScreeCompany,
		DatePicker
	},
	watch: {
		"$route.matched": function(n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		},
		"sendRuleForm.courierNumber": function(val) {
			if(val) {
				if(this.isLook) {
					console.log("11111")
					this.sendDialogData.loading = false
				}else {
					console.log("222")
					this.sendDialogData.loading = false
				}
			}else {
				if(this.isLook) {
					console.log("3333")
					this.sendDialogData.loading = false
				}else {
					console.log("4444")
					this.sendDialogData.loading = true
				}
				console.log("sendRuleForm.courierNumber")
			}
		},
	},
	data() {
		return {
			allowField:['companyId'],
			ruleForm: {
				// expressName: '',
				// courierNumber: '',
				invoiceImg: '',
				invoiceNumber: ''
			},
			sendRuleForm: {
				id: '',
				expressName: '',
				courierNumber: '',
				mailImg: ''
			},
			invoice_imgs: '',
			invoiceId: '',
			dialogData:{
				visible: false,
				title: '',
				width: '40%',
				loading: false,
				modal: false
			},
			sendDialogData:{
				visible: false,
				title: '',
				width: '40%',
				loading: true,
				modal: false
			},
			showTitle: '',
			showButton: ['cancel'],
			checkTitle: '',
			loadingStaus: false,
			tabsList: [],
			activeName: 'all',
			// 分页信息
			pagingData:{
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			options: [],
			value: "公司名称",
			dataList: [],
			columns: [
				{
					title: "序号",
					value: "id",
					header_align: "center",
					align: "center",
				},
				//      {
				// title: "项目联系人",
				// value: "name",
				// header_align: "center",
				// align: "center",
				//      },
				{
					title: "项目类型",
					value: "categorys_text",
					header_align: "center",
					align: "center",
				},
				{
					title: "项目需求名称",
					value: "title",
					header_align: "center",
					align: "center",
				},
				{
					title: "项目服务地区",
					value: 'address',
					header_align: "center",
					align: "center",
				},
				{
					title: "项目申请时间",
					value: "created_at",
					header_align: "center",
					align: "center",
				}
			],
			searchCondition:{
				status:'',
				// contact_phone:'',
				time:''
			},
			typeList:[
				{id:'0',name:'待审核'},
				{id:'1',name:'审核通过'},
				{id:'2',name:'审核拒绝'}
			],
			exDialogData:{
				visible: false,
				title: '审核',
				width: '35%',
				loading: false,
				modal: false
			},
			refuseData:{
				remark:'抱歉，您当前没有通过发布项目审核'
			},
			refuseRules: {
				// remark: [
				// 	{ required: true, message: '请输入拒绝原因', trigger: 'blur' },
				// ]
			},
			isLook: false,
			ph_user_id:this.$route.query.id,
			disabled: false,
			company_name:this.$route.query.company_name,
			contact_phone:this.$route.query.contact_phone,
			company_status:this.$route.query.status,
		};
	},
	methods: {
		// 重置分页
		async resetPage() {
			this.$refs.apeTable.currentPage = 1
		},
		// 切换页码操作
		async switchPaging() {
			this.init();
		},
		// 搜索
		searchButton() {
			this.resetPage()
			this.init('search')
		},
		//获取选中日期的值
		dataSearch(value) {
			this.searchCondition.time_value = value
		},
		ScreeCompany(v, name) {
			if (name == 'company') {
				if(v) {
					this.searchCondition.company_id = v
				} else {
					delete this.searchCondition.company_id
				}
				this.init('search')
			}
		},
		//获取列表
		async init(type) {
			console.log(type)
			this.loadingStaus=true
			let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			let searchCondition = this.handleSearchCondition()
			Object.assign(searchCondition,pagingInfo)
			this.dataList = []
			let { data, pages} = await this.$api.getPaihuoProjectList(searchCondition)
			this.$nextTick(() => {
				data.forEach(function(item1,index){
					data[index].categorys_text = "";
					if(item1.categorys) {
						item1.categorys.forEach(function(item2){
							if(data[index].categorys_text=="") {
								data[index].categorys_text = item2.display_name;
							} else {
								data[index].categorys_text = data[index].categorys_text+";"+item2.display_name;
							}
						})
					}
				})
				this.dataList=data
			})
			this.pagingData.total = pages.total
			this.offset = pages.offset
			this.loadingStaus=false
		},
		// 处理搜索条件
		handleSearchCondition() {
			let condition = {}
			if (this.searchCondition.status) {
				condition.status = this.searchCondition.status
			}
			// if (this.searchCondition.contact_phone) {
				// 	condition.contact_phone = this.searchCondition.contact_phone
			// }
			if (this.searchCondition.time_value) {
				condition.start_time = this.searchCondition.time_value[0]
				condition.end_time = this.searchCondition.time_value[1]
			}
			condition.ph_user_id = this.ph_user_id.toString();
			return condition
		},
		//返回上一页
		goBack() {
			this.$router.push({ path: "/paihuo" });
		},
		// 处理模态框，确定事件
		handleConfirm() {
			// 调用组件的数据验证方法
			this.$refs['refuseForm'].validate((valid) => {
				if (valid) {
					if(!this.refuseData.status) {
						this.$message.error('请选择审核通过或拒绝！')
						return false;
					}
					if(this.refuseData.status==1) {
						this.refuseData.remark = "";
					}
				this.formRefuseSubmit()
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！')
				}
			})
		},
		// 处理模态框，关闭事件
		dialogClose() {
			this.exDialogData.visible = false
			// this.exDialogData.loading = true
			// this.formData = {}
			// this.attachmentUploadFileList = []
			this.refuseData = {remark:"抱歉，您当前没有通过发布项目审核"}
		},
		// 审核项目
		examine(id){
			this.exDialogData.visible = true
			this.refuseData.id = id
		},
		// 项目详情
		toInfo(id){
			console.log(id)
			this.$router.push({
				path:'/paihuo_project/info',
				query:{id:this.ph_user_id,project_id:id,company_name:this.company_name,contact_phone:this.contact_phone,company_status:this.company_status}
			})
		},
		// 审核数据提交
		async formRefuseSubmit() {
			var data = {};
			data.status = this.refuseData.status;
			data.remark = this.refuseData.remark;
			const res = await this.$api.examinePaihuoProject(this.refuseData.id,data)
			if (res) {
				this.$message.success('操作成功。')
				this.exDialogData.visible = false
				this.exDialogData.loading = false
			} else {
				this.$message.error('审核失败。')
			}
			this.init()
		}
	},
	computed: {
		...mapGetters(['userPermissions'])
	},
	mounted() {
		this.resetPage()
		this.init()
	},
};
</script>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.operation-btn
  margin: 0 20px
.el-button + .el-button
  margin-left: 0
.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 280px;
}

.invoice-img {
  width: 100%
}
.new-mail-img
  width: 100%
  display: none
.mail-img
  width: 100%
.mail-title
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.mail-content
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.invoice-wrapper
  margin-left: 55px
.expend
  text-align: center
  margin-top: 20px
  color: #333
/deep/.demo-ruleForm .el-form-item__label
  padding: 0!important
/deep/.vue-uploader
  width: 98%
</style>






